module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner_newarrival_importdress-a9657da35c0a77e53246787d4efabfeb.jpg";